import React, { useState, useEffect, useCallback } from 'react';
import { HiCheckCircle, HiXCircle, HiExclamationCircle, HiBell, HiInformationCircle } from 'react-icons/hi';
import { classificarMensagem, fetchConfigFromServer } from '../../utils/classificarMensagem';

const AUTH = 'Basic ' + btoa('Portal:Portal1163');

const nivelKey = { 'Moderado': 'moderado', 'Normal': 'normal', 'Grave': 'grave' };

const DashboardKPIs = () => {
  const [data, setData] = useState({ grave: null, moderado: null, normal: null, online: null, offline: null });
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchAll = useCallback(async () => {
    const [excRes, awsRes] = await Promise.allSettled([
      fetch('https://v1-csapi.compsoft.com.br:823/pdv_exception/false', { headers: { Authorization: AUTH } }),
      fetch('https://v1-csapi.compsoft.com.br:823/aws', { headers: { Authorization: AUTH } }),
    ]);

    await fetchConfigFromServer().catch(() => {});

    const next = { grave: 0, moderado: 0, normal: 0, online: 0, offline: 0 };

    if (excRes.status === 'fulfilled' && excRes.value.ok) {
      const exc = await excRes.value.json();
      exc.filter(r => r.cnpj !== '11111111111111').forEach(r => {
        const { nivel } = classificarMensagem(r.mensagem);
        next[nivelKey[nivel]]++;
      });
    }
    if (awsRes.status === 'fulfilled' && awsRes.value.ok) {
      const aws = await awsRes.value.json();
      next.online  = aws.filter(s => s.status === 'ON').length;
      next.offline = aws.filter(s => s.status !== 'ON').length;
    }

    setData(next);
    setLastUpdate(new Date());
  }, []);

  useEffect(() => {
    fetchAll();
    const t = setInterval(fetchAll, 60_000);
    return () => clearInterval(t);
  }, [fetchAll]);

  const loading = data.grave === null;

  const items = [
    {
      icon: <HiExclamationCircle size={24} />,
      value: data.grave,
      label: 'Exceções',
      sublabel: 'Grave',
      status: loading ? 'neutral' : data.grave > 0 ? 'danger' : 'success',
    },
    {
      icon: <HiBell size={24} />,
      value: data.moderado,
      label: 'Alertas',
      sublabel: 'Moderado',
      status: loading ? 'neutral' : data.moderado > 0 ? 'warning' : 'success',
    },
    {
      icon: <HiInformationCircle size={24} />,
      value: data.normal,
      label: 'Avisos',
      sublabel: 'Normal',
      status: loading ? 'neutral' : data.normal > 0 ? 'success' : 'neutral',
    },
    {
      icon: <HiCheckCircle size={24} />,
      value: data.online,
      label: 'Servidores Online',
      sublabel: null,
      status: loading ? 'neutral' : 'success',
    },
    {
      icon: <HiXCircle size={24} />,
      value: data.offline,
      label: 'Servidores Offline',
      sublabel: null,
      status: loading ? 'neutral' : data.offline > 0 ? 'danger' : 'neutral',
    },
  ];

  return (
    <div className="cs-kpi-row">
      {items.map((item, i) => (
        <div key={i} className={`cs-kpi-card cs-kpi-${item.status}`}>
          <div className="cs-kpi-icon">{item.icon}</div>
          <div className="cs-kpi-body">
            <span className="cs-kpi-value">{loading ? '—' : item.value}</span>
            <span className="cs-kpi-label">{item.label}</span>
            {item.sublabel && (
              <span className="cs-kpi-sublabel" style={{ color: 'inherit', opacity: 0.7 }}>
                {item.sublabel}
              </span>
            )}
          </div>
        </div>
      ))}
      {lastUpdate && (
        <span className="cs-kpi-ts">
          atualizado {lastUpdate.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
        </span>
      )}
    </div>
  );
};

export default DashboardKPIs;
